module.exports = __webpack_public_path__ + "assets/img/icon-back-arrow.svg?13834dd492106302a59238482edc39b4";